export default __webpack_public_path__ + "static/neymar-5fee2f7efc57e70efd2f2a53b9d4dbfd.jpeg";